import { Navigate, Outlet, Routes, Route } from "react-router-dom";
import PrivateRoute from "../components/common/PrivateRoute.js";
import Layout from "../components/Products/Atendabot/components/layout/Layout.tsx";

import Dashboard from "../components/Products/Atendabot/pages/Dashboard.tsx";
import Conversations from "../components/Products/Atendabot/pages/Conversations.tsx";
import Agenda from "../components/Products/Atendabot/pages/Agenda.tsx";
import Promotions from "../components/Products/Atendabot/pages/Promotions.tsx";
import Menu from "../components/Products/Atendabot/pages/Menu.tsx";
import Integrations from "../components/Products/Atendabot/pages/Integrations.tsx";
import SaiposIntegration from "../components/Products/Atendabot/pages/SaiposIntegration.tsx";
import SischefIntegration from "../components/Products/Atendabot/pages/SischefIntegration.tsx";
import BlockedNumbers from "../components/Products/Atendabot/pages/BlockedNumbers.tsx";
import Orders from "../components/Products/Atendabot/pages/Orders.tsx";
import OrderHistory from "../components/Products/Atendabot/pages/OrderHistory.tsx";
import PromptPage from "../components/Products/Atendabot/pages/PromptPage.tsx";
import WhatsAppPage from "../components/Products/Atendabot/pages/WhatsAppPage.tsx";
import InfoExtra from "../components/Products/Atendabot/pages/InfoExtra.tsx";
import Atalhos from "../components/Products/Atendabot/pages/Atalhos.tsx";
import Transbordo from "../components/Products/Atendabot/pages/Transbordo.tsx";
import { AtendabotPrivacyPolicy, AtendabotTermsOfUse } from "../components/Products/Atendabot/pages/Legal.tsx";

const AtendabotRoutes = () => {
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute product="atendabot" allowTrialRestricted allowAtendabotAtendente>
            <Layout><Outlet /></Layout>
          </PrivateRoute>
        }
      >
      <Route
        path="/"
        element={
          <PrivateRoute product="atendabot" allowAtendabotAtendente>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="whatsapp"
        element={
          <PrivateRoute product="atendabot" allowTrialRestricted ownerOnly>
            <WhatsAppPage />
          </PrivateRoute>
        }
      />
      <Route
        path="conversations"
        element={
          <PrivateRoute product="atendabot" allowAtendabotAtendente>
            <Conversations />
          </PrivateRoute>
        }
      />
      <Route
        path="conversations/:id"
        element={
          <PrivateRoute product="atendabot" allowAtendabotAtendente>
            <Conversations />
          </PrivateRoute>
        }
      />
      <Route
        path="agenda"
        element={
          <PrivateRoute product="atendabot" foodOnly={false} allowAtendabotAtendente>
            <Agenda />
          </PrivateRoute>
        }
      />
      <Route
        path="promotions"
        element={
          <PrivateRoute product="atendabot">
            <Promotions />
          </PrivateRoute>
        }
      />
      <Route
        path="menu"
        element={
          <PrivateRoute product="atendabot" foodOnly>
            <Menu />
          </PrivateRoute>
        }
      />
      <Route
        path="prompt"
        element={
          <PrivateRoute product="atendabot" allowTrialRestricted>
            <PromptPage />
          </PrivateRoute>
        }
      />
      <Route
        path="forms"
        element={
          <PrivateRoute product="atendabot">
            <Navigate to="/atendabot/forms/info-extra" replace />
          </PrivateRoute>
        }
      />
      <Route
        path="forms/info-extra"
        element={
          <PrivateRoute product="atendabot">
            <InfoExtra />
          </PrivateRoute>
        }
      />
      <Route
        path="atalhos"
        element={
          <PrivateRoute product="atendabot">
            <Atalhos />
          </PrivateRoute>
        }
      />
      <Route
        path="transbordo"
        element={
          <PrivateRoute product="atendabot">
            <Transbordo />
          </PrivateRoute>
        }
      />
      <Route
        path="integrations"
        element={
          <PrivateRoute product="atendabot" foodOnly>
            <Integrations />
          </PrivateRoute>
        }
      />
      <Route
        path="integrations/saipos"
        element={
          <PrivateRoute product="atendabot" foodOnly>
            <SaiposIntegration />
          </PrivateRoute>
        }
      />
      <Route
        path="integrations/sischef"
        element={
          <PrivateRoute product="atendabot" foodOnly>
            <SischefIntegration />
          </PrivateRoute>
        }
      />
      <Route
        path="blocked"
        element={
          <PrivateRoute product="atendabot">
            <BlockedNumbers />
          </PrivateRoute>
        }
      />
      <Route
        path="orders"
        element={
          <PrivateRoute product="atendabot" foodOnly>
            <Orders />
          </PrivateRoute>
        }
      />
      <Route
        path="orders/history"
        element={
          <PrivateRoute product="atendabot" foodOnly>
            <OrderHistory />
          </PrivateRoute>
        }
      />
      <Route
        path="termos-de-uso"
        element={
          <PrivateRoute product="atendabot" allowTrialRestricted>
            <AtendabotTermsOfUse />
          </PrivateRoute>
        }
      />
      <Route
        path="politica-de-privacidade"
        element={
          <PrivateRoute product="atendabot" allowTrialRestricted>
            <AtendabotPrivacyPolicy />
          </PrivateRoute>
        }
      />
      <Route
        path="*"
        element={
          <PrivateRoute product="atendabot">
            <Navigate to="/atendabot" replace />
          </PrivateRoute>
        }
      />
      </Route>
    </Routes>
  );
};

export default AtendabotRoutes;
